<jw-modal id="newContactModal">
  <div class="row">
    <div class="col">
      <h5>New Contact</h5>
    </div>
  </div>

  <div class="row">
    <div class="form-group col-md-4">
      <label>First Name</label>
      <input type='text' [class.is-invalid]='!this.contact.firstName' class='form-control' [(ngModel)]='this.contact.firstName' />
    </div>
    <div class="form-group col-md-4">
      <label>Last Name</label>
      <input type='text' [class.is-invalid]='!this.contact.lastName' class='form-control' [(ngModel)]='this.contact.lastName' />
    </div>
    <div class='form-group col-md-4'>
      <label>Phone Number</label>
      <input type='text' [class.is-invalid]='!this.contact.businessPhone' [(ngModel)]="this.contact.businessPhone" class='form-control'/>
    </div>
    <div class="form-group col-md-4">
      <label>Job Role</label>
      <select [class.is-invalid]='this.contact.roleId === -1' class='form-control' (change)='this.contact.roleId = $event.target.value; this.contact.role = {id: this.contact.roleId}'>
        <option value='-1'>Select a job role</option>
        @for (role of this.roles; track role) {
          <option [selected]='this.contact.roleId === role.id' [value]='role.id'>{{ role.name }}</option>
        }
      </select>
    </div>
  </div>

  <div class="row">
    <div class="col">
      <button class='btn btn-success' (click)='this.save()'>Save</button>
      <button class='btn btn-warnign' (click)='this.close()'>Close</button>
    </div>
  </div>
</jw-modal>
